import { render, staticRenderFns } from "./sharePanel.vue?vue&type=template&id=707d482a&scoped=true&"
import script from "./sharePanel.vue?vue&type=script&lang=js&"
export * from "./sharePanel.vue?vue&type=script&lang=js&"
import style0 from "./sharePanel.vue?vue&type=style&index=0&id=707d482a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d482a",
  null
  
)

export default component.exports